//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import angular from 'angular';

import template from '@streams-drawer/streams-drawer-top-bar/item-removal-confirmation-modal/item-removal-confirmation-modal.html';

interface ItemRemovalConfirmationModal {
  // Bindings
  itemCount: number;
}
class ItemRemovalConfirmationModal {
  public itemCountText = this.itemCount === 1 ? 'item' : 'items';
}

angular.module('curalate').component('itemRemovalConfirmationModal', {
  controller: [
    ItemRemovalConfirmationModal,
  ],
  bindings: {
    itemCount: '<',
    onCloseRemovalConfirmationModal: '&',
    onRemoveItems: '&',
  },
  template,
});
